module.exports = __webpack_public_path__ + "site/img/49.01dff6ec.jpg";